import { supabase } from "./supabaseClient";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export async function enablePushOnThisDevice() {
  const publicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
  if (!publicKey) return { error: new Error("Missing VITE_VAPID_PUBLIC_KEY") };

  if (!("serviceWorker" in navigator)) return { error: new Error("Service workers not supported") };
  if (!("PushManager" in window)) return { error: new Error("Push not supported") };

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { error: new Error("Notifications permission not granted") };

  const reg = await navigator.serviceWorker.ready;

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  const json = sub.toJSON();
  const endpoint = json.endpoint;
  const p256dh = json.keys?.p256dh;
  const auth = json.keys?.auth;

  if (!endpoint || !p256dh || !auth) return { error: new Error("Invalid subscription") };

  const { data: userData, error: userErr } = await supabase.auth.getUser();
  if (userErr) return { error: userErr };
  const userId = userData?.user?.id;
  if (!userId) return { error: new Error("Not signed in") };

  const { error } = await supabase
    .from("push_subscriptions")
    .upsert({ user_id: userId, endpoint, p256dh, auth }, { onConflict: "user_id,endpoint" });

  if (error) return { error };
  return { data: { endpoint } };
}
